import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import FirstSlider from "../../components/pages/Home/MainSlider/FirstSlider";
import PreviousPage from "../../components/partials/PreviousPage/PreviousPage";
import Textile from "../../components/pages/SalesAndNews/Textile/Textile";

const SalesAndNewsPage: React.FC = () => {
  return (
    <Layout>
      <div className="container">
        <PreviousPage currentPage="Акции и новости" />
      </div>
      <FirstSlider />
      <Textile />
      <Feedback />
    </Layout>
  );
};

export default SalesAndNewsPage;
